import { FC } from 'react';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import DayJsUtils from '@date-io/dayjs';
import thunkMiddleware from 'redux-thunk';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core/styles';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import { SnackbarProvider } from 'notistack';
import { resources } from '../../config/resources';
import InternationalizationProvider from '../InternationalizationProvider';
import { theme } from '../../config/theme';
import rootReducer from '../../store/reducers/index';

import AxiosProvider from '../AxiosProvider';

const AppProvider: FC = ({ children }) => {
    const composeEnhancers =
        process.env.NODE_ENV === 'production'
            ? compose
            : composeWithDevTools({
                  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
              });

    const persistConfig = {
        key: 'GotMy',
        storage,
    };
    const persistedReducer = persistReducer(persistConfig, rootReducer);
    const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

    return (
        <InternationalizationProvider resources={resources}>
            <AxiosProvider>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <SnackbarProvider
                        maxSnack={3}
                        autoHideDuration={5000}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                    >
                        <Provider store={store}>
                            <PersistGate persistor={persistStore(store)}>
                                <MuiPickersUtilsProvider utils={DayJsUtils}>
                                    {children}
                                </MuiPickersUtilsProvider>
                            </PersistGate>
                        </Provider>
                    </SnackbarProvider>
                </ThemeProvider>
            </AxiosProvider>
        </InternationalizationProvider>
    );
};

export default AppProvider;
